// extracted by mini-css-extract-plugin
export default {"header":"daily-specials-A8IlV","header--highlighted":"daily-specialsYdExA9"};